export default "__VITE_ASSET__d992ba29__"